if (!customElements.get("variant-selects-custom")) {
  customElements.define(
    "variant-selects-custom",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
      }
      sectionId = this.dataset.section;
      showQuantity = false;
      resetValue = 1;
      cent = 100;
      showAddToCart = false;
      variant_id = null;

      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = this.getInputForEventTarget(event.target);

          if (
            target.getAttribute("name") == "quantity_calculator" ||
            target.getAttribute("name") == "quantity"
          ) {
            if (target.getAttribute("name") == "quantity_calculator") {
              this.quantity_calculator();
            }
            return false;
          }

          this.updateSelectionMetadata(event);

          this.handleOptionValueChange({
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });

          if (!window.location.pathname.includes("/cart")) {
            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          }
        });

        this.dispatchEvent(new Event("change"));

        // Add submit button event listener
        const addToCartButton = this.querySelector(".add-to-cart-button");
        if (addToCartButton) {
          addToCartButton.addEventListener(
            "click",
            this.submitToCart.bind(this)
          );
        }

        /** setup variant_id */
        const selectedVariant = this.querySelector(
          "[data-selected-variant]"
        )?.innerHTML;
        let currVariant = !!selectedVariant
          ? JSON.parse(selectedVariant).id
          : null;

        if (currVariant !== null) {
          this.variant_id = currVariant;
        }
      }

      submitToCart() {
        const quantity = parseInt(
          this.querySelector('[name="quantity"]').value,
          10
        );
        const variantId = this.variant_id;

        if (!variantId || isNaN(quantity) || quantity <= 0) {
          console.error("Variant ID or Quantity is invalid.");
          return;
        }

        // Submit to Shopify cart
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to add to cart");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Added to cart:", data);
            // Optionally redirect to the cart page
            window.location.href = "/cart";
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
          });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        //this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: this.handleUpdateProductInfo(productUrl),
        });
      }
      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.variant_id = variant.id;
          this.renderCustomPrice(variant);
        };
      }
      renderCustomPrice(variant) {
        /* price = 50 / 100 = 0.5 = 1 qty / step = 0.5 min = 0.5 and quantity = number * new price */
        if (variant === null) return;
        if (
          typeof variant.selectedVariantCustomPrice !== "undefined" &&
          variant.selectedVariantCustomPrice === "true"
        ) {
          let step = variant.price / this.cent;
          let min = step;
          let value = this.resetValue;
          let quantity_calculator = this.querySelector(
            '[name="quantity_calculator"]'
          );
          quantity_calculator.setAttribute("step", step);
          quantity_calculator.setAttribute("min", min);
          quantity_calculator.value = value;
          quantity_calculator
            .closest(".quantity-container")
            .classList.remove("hidden");
          quantity_calculator.focus();
          this.querySelector('[name="quantity"]').value = value / step;
          this.showQuantity = true;
        } else {
          this.querySelector('[name="quantity_calculator"]').value =
            this.resetValue;
          this.querySelector('[name="quantity_calculator"]').setAttribute(
            "step",
            this.resetValue
          );
          this.querySelector('[name="quantity_calculator"]').setAttribute(
            "min",
            this.resetValue
          );
          this.querySelector('[name="quantity_calculator"]')
            .closest(".quantity-container")
            .classList.add("hidden");
          this.querySelector('[name="quantity"]').value = this.resetValue;
          this.showQuantity = false;
        }
      }
      quantity_calculator() {
        const stepInput = this.querySelector('[name="quantity_calculator"]');
        const stepValue = parseFloat(stepInput.getAttribute("step")) || 1; // Default to 1 if no step
        const inputValue = parseFloat(stepInput.value);

        // Validate against the step
        if (!Number.isNaN(inputValue) && inputValue % stepValue !== 0) {
          // Snap to the nearest multiple of the step value
          const nearestValidValue =
            Math.round(inputValue / stepValue) * stepValue;
          stepInput.value = nearestValidValue;
        }

        this.querySelector('[name="quantity"]').value =
          stepInput.value / stepInput.step;
      }
      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects-custom [data-selected-variant]"
        )?.innerHTML;

        const variantReturn = !!selectedVariant
          ? JSON.parse(selectedVariant)
          : null;
        if (variantReturn !== null) {
          let selectedVariant = productInfoNode.querySelector(
            "variant-selects-custom [data-selected-variant]"
          );
          variantReturn.selectedVariantCustomPrice =
            selectedVariant.dataset.selectedVariantCustomPrice;
        }
        return variantReturn;
      }

      updateSelectionMetadata({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }
    }
  );
}
